// extracted by mini-css-extract-plugin
export var copyIcon = "_rr-2";
export var discountCard = "_rr-0";
export var discountCode = "_rr-3";
export var discountContent = "_rr-1";
export var loadingCard = "_rr-4";